import React, {Component} from 'react';
import ForcePlayers from './molecules/force-players';
import PlayersQuantity from './molecules/players-quantity';
import PositionsBox from './molecules/positions-box';
import SubValue from './molecules/sub-value';

class ProjectedOwnershipForce extends Component {
    render() {
        return (
            <div className="gap-y">
                <div className="form-inline">
                    <ForcePlayers />
                    <PlayersQuantity />
                    <div className="form-sub-text">players</div>
                </div>
                <div className="form-inline gap-row-5">
                    <PositionsBox />
                </div>
                <div className="form-inline flex-nowrap">
                    <div className="form-sub-text">under</div>
                    <SubValue />
                    <div className="form-sub-text wide-block">projected ownership in each lineup</div>
                </div>
            </div>
        );
    }
}

export default ProjectedOwnershipForce;
